import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 21.99"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m20.68 5.94-2.22-1.51v-2.6c0-.56-.17-1.01-.49-1.34-.33-.33-.78-.49-1.34-.49H5.25c-.56 0-1.01.17-1.34.49-.33.33-.49.78-.49 1.34v2.78L1.43 5.94A2.89 2.89 0 0 0 .14 8.03c-.08.12-.13.26-.13.41v10.58c0 1.66 1.3 2.97 2.97 2.97h15.93c1.66 0 2.97-1.3 2.97-2.97v-9.7s0-.05-.01-.08c.4-1.24-.08-2.56-1.18-3.3Zm-.82 3.76-1.4.95V6.17l1.4.89c.45.3.71.78.71 1.32s-.26 1.02-.71 1.32m.63 1.25v8.08c0 .12-.02.25-.05.38l-5.02-5.02zm-17.07-.37-1.29-.87c-.45-.3-.71-.78-.71-1.32s.26-1.02.71-1.32l1.29-.86zm-2.03 8.45V10.8s.02.02.03.02l5.13 3.47-5.11 5.11c-.03-.13-.05-.25-.05-.38Zm6.54-3.8.21.15c1.74 1.16 3.97 1.16 5.83 0l.08-.05 5.24 5.24c-.13.03-.25.05-.38.05H2.97c-.12 0-.25-.02-.38-.05l5.33-5.33Zm.92-.97-4.04-2.74V1.83c0-.11.03-.18.06-.26l.03-.09c.03 0 .06-.02.09-.03.07-.03.15-.06.26-.06h11.38c.11 0 .19.03.26.06l.09.03c0 .03.02.06.03.09.03.07.06.15.06.26v9.75l-3.93 2.66c-1.33.88-2.98.88-4.3 0Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.24 4.07H7.41c-.38 0-.72.34-.72.72 0 .33.33.75.7.75l6.85-.03c.38 0 .72-.34.72-.72s-.34-.72-.72-.72M14.24 8.05H7.41c-.38 0-.72.34-.72.72 0 .33.33.75.7.75l6.85-.03c.38 0 .72-.34.72-.72s-.34-.72-.72-.72"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }